import { Stage } from '@/interfaces/stage';
import { StageResource, stageResource } from '@/resources/stage.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł etapu
 *
 * @export
 * @class StageModule
 * @extends {EntityModule<Stage, StageResource>}
 */
export class StageModule extends EntityModule<Stage, StageResource> {
  constructor() {
    super(stageResource);
  }
}

export default new StageModule();
